<template>
  <el-dialog :title="info.title" :close-on-click-modal="false" :visible.sync="visible" append-to-body>
    <p>{{ $t('1410') }}: {{ info.group_name }}</p>
    <el-table :data="info.data" ref="table" border v-load="loading" :loading-text="$t('989')">
      <template v-for="(item, index) in table[info.type]">
        <template v-if="item.prop == 'url'">
          <el-table-column :key="index" :prop="item.prop" :align="item.align" :label="item.label" :width="item.width">
            <template slot-scope="scope" v-if="scope.row.url">
              <el-image style="width: 100px; height: 100px" :src="scope.row.url"></el-image>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column :key="index" :prop="item.prop" :align="item.align" :label="item.label" :width="item.width">
          </el-table-column>
        </template>
      </template>
    </el-table>
  </el-dialog>
</template>

<script>
import { attendanceDetail, leaveDetail } from 'api/Attendance'

export default {
  data() {
    return {
      visible: false,
      title: '',
      info: {},
      loading: false,
      table: {
        leave: [
          {
            prop: 'leave_type_name',
            label: this.$t('98'), // 请假类型
            width: 180,
            align: 'center'
          },
          {
            prop: 'leave_start_time',
            label: this.$t('1536'), // 请假开始时间
            width: 180,
            align: 'center'
          },
          {
            prop: 'leave_end_time',
            label: this.$t('1537'), // 请假结束时间
            width: 180,
            align: 'center'
          },
          {
            prop: 'audit_reason',
            label: this.$t('remark'), // 备注
            width: '',
            align: 'center'
          }
        ],
        attendance: [
          {
            prop: 'attendance_time',
            label: this.$t('1363'),
            width: 180,
            align: 'center'
          },
          {
            prop: 'click_time',
            label: this.$t('1411'),
            width: 180,
            align: 'center'
          },
          {
            prop: 'click_state_msg',
            label: this.$t('1412'),
            width: 180,
            align: 'center'
          },
          {
            prop: 'address',
            label: this.$t('1413'),
            width: 180,
            align: 'center'
          },
          {
            prop: 'remark',
            label: this.$t('1414'),
            width: 180,
            align: 'center'
          },
          {
            prop: 'url',
            label: this.$t('1415'),
            width: 180,
            align: 'center'
          }
        ]
      }
    }
  },
  methods: {
    init(obj) {
      this.visible = true
      const data = {
        staff_id: obj.staff_id,
        attendance_date: obj.attendance_date,
        attendance_category: obj.attendance_category
      }
      this.info.type = obj.type
      if (obj.type === 'leave') {
        this.leaveDetail(data)
      } else {
        this.attendanceDetail(data)
      }
    },

    async leaveDetail(obj) {
      this.loading = true
      const res = await leaveDetail(obj)
      this.loading = false
      this.info = {
        ...this.info,
        title: res.data.title,
        group_name: res.data.group_name,
        data: [...res.data.list]
      }
    },
    async attendanceDetail(obj) {
      this.loading = true
      const res = await attendanceDetail(obj)
      this.loading = false
      this.info = {
        ...this.info,
        title: res.data.title,
        group_name: res.data.group_name,
        data: [res.data]
      }
    }
  }
}
</script>
